import React from 'react';

interface IProps {
  width?: string;
  height?: string;
  stroke?: string;
  strokeWidth?: string;
}

const Check: React.FC<IProps> = ({ stroke, strokeWidth, ...rest }) => (
  <svg viewBox="0 0 21 17" {...rest}>
    <path
      d="M19 2L7.7 15 2 9.4"
      fill="none"
      stroke={stroke}
      strokeLinecap="round"
      strokeWidth={strokeWidth}
    />
    <title>Check Icon</title>
  </svg>
);

Check.defaultProps = {
  stroke: 'black',
  strokeWidth: '2.5',
};

export default Check;
